import { StructuredDataOrganization } from "../types";

/**
 * Creates Baana Organization structured data
 * This is a shared builder used across multiple pages
 */
export const createBaanaOrganization = (): StructuredDataOrganization => ({
  "@type": "Organization",
  "@id": "https://baana.nettiauto.com/#organization",
  name: "Baana",
  alternateName: "Nettiauto",
  url: "https://baana.nettiauto.com",
  description:
    "Kilpailutuspalvelu autosi, moottoripyöräsi tai muun ajoneuvon myyntiin liikkeelle. Kilpailuta tarjoukset ja myy eniten tarjoavalle nopeasti ja luotettavasti.",
  logo: {
    "@type": "ImageObject",
    url:
      import.meta.env.VITE_BAANA_LOGO_HERO_URL ??
      "https://baana-frontpage-prod.s3.eu-west-1.amazonaws.com/images/Baana_by_nettiauto_hero.webp",
    width: "200",
    height: "60"
  },
  contactPoint: [
    {
      "@type": "ContactPoint",
      contactType: "customer service",
      description: "Asiakaspalvelu Baana yksityisille käyttäjille",
      telephone: "+358-600-04070",
      areaServed: "FI"
    },
    {
      "@type": "ContactPoint",
      contactType: "sales",
      description: "Asiakaspalvelu Baana yritysasiakkaille",
      telephone: "+358-10-231-1710",
      areaServed: "FI"
    }
  ],
  sameAs: [
    "https://www.facebook.com/baana.nettiauto",
    "https://www.tiktok.com/@baana.nettiauto"
  ]
});
